import { createContext } from "react";

import { RefreshTimer } from "./types";

export const RefreshContext = createContext<RefreshTimer | null>(null);
